import intlPolyfill from './intl'

export default function () {
  return intlPolyfill
}
